import { render, staticRenderFns } from "./Waiting_budget.vue?vue&type=template&id=2f45df62&scoped=true"
import script from "./Waiting_budget.vue?vue&type=script&lang=js"
export * from "./Waiting_budget.vue?vue&type=script&lang=js"
import style0 from "./Waiting_budget.vue?vue&type=style&index=0&id=2f45df62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f45df62",
  null
  
)

export default component.exports